// extracted by mini-css-extract-plugin
export default {"popper":"Tooltip_popper__nj17o"};